import React, { useState, useEffect } from "react";

// SUIR
import {
  Modal,
  Button,
  Input,
} from "semantic-ui-react";

const ShareParcelsModal = ({ selectedFeature, open, setOpen, domain }) => {
  return (
    <Modal onClose={() => setOpen(false)} open={true}>
      <Modal.Header style={{ fontSize: "1.1em" }}>Share Parcel</Modal.Header>
      <Modal.Content style={{ textAlign: "center" }}>
        <p>This link will zoom to the currenlty selected Parcel on load.</p>

        <Input
          action={{
            icon: "copy",
            onClick: () => {
                navigator.clipboard.writeText(
                  `${domain}?parcelid=${selectedFeature.attributes.PARCEL_NO}`
                );
            },
          }}
          value={`${domain}?parcelid=${selectedFeature.attributes.PARCEL_NO}`}
          style={{ maxWidth: "500px", margin: "0px auto", width: "100%" }}
        />
      </Modal.Content>
      <Modal.Actions>
        <Button secondary onClick={() => setOpen(false)}>
          Cancel
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default ShareParcelsModal;
